import { GlassCard, BentoGrid, BentoCell } from "@kj/design-system";

const TILES = [
  { label: "DAU / MAU", v: "—" },
  { label: "Match success rate", v: "—" },
  { label: "Translation BLEU", v: "48.6" },
  { label: "Voice p50", v: "—" },
];

export default function AnalyticsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Analytics</h1>
      <BentoGrid>
        {TILES.map((t) => (
          <BentoCell key={t.label} span="sm" height="sm" eyebrow={t.label}>
            <div className="text-3xl font-bold">{t.v}</div>
          </BentoCell>
        ))}
      </BentoGrid>
      <GlassCard padding="lg" radius="2xl">
        <div className="text-sm text-fg-muted">
          차트는 Sprint 3에서 ClickHouse + recharts로 시각화 예정.
        </div>
      </GlassCard>
    </div>
  );
}
